import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    listUserFilters: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task-user-filter/',
                    method: 'GET',
                    types: [
                        types.LIST_LOCATION_TASK_USER_FILTERS_REQUEST,
                        types.LIST_LOCATION_TASK_USER_FILTERS_SUCCESS,
                        types.LIST_LOCATION_TASK_USER_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    saveUserFilters: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task-user-filter/',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SAVE_LOCATION_TASK_USER_FILTERS_REQUEST,
                        types.SAVE_LOCATION_TASK_USER_FILTERS_SUCCESS,
                        types.SAVE_LOCATION_TASK_USER_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
}
